const Platform = require('PSPlatform');

const ScaleData = cc.Class({
    name: 'ScaleData',
    properties: {
        aspectRatioTo: 0,
        coefficient: 1
    }
})

cc.Class({
    extends: cc.Component,

    properties: {
        dekstopScaling: [ScaleData],
        handleMobile: false,
        mobileScaling: {
            default: [],
            type: ScaleData,
            visible: function () {
                return this.handleMobile
            }
        }
    },

    onLoad () {
        this.resizeManager = cc.find('ResizeManager').getComponent('ResizeManager');

        if (!this.resizeManager) {
            this.node.removeComponent('PSScaleAspectChanger');
            cc.warn('PSScaleAspectChanger: no resize manager found');
        }

        this.originScaleX = this.node.scaleX;
        this.originScaleY = this.node.scaleY;

        this.scaleData = (Platform.isMobile && this.handleMobile) ? this.mobileScaling : this.dekstopScaling;

        this.scaleData.sort(function (a, b) {
            return a.aspectRatioTo - b.aspectRatio;
        });


        if (this.scaleData.length) {
            this.resizeManager.appendNode(this);
        } else {
            this.node.removeComponent('PSScaleAspectChanger');
        }

    },

    onDestroy() {
        this.resizeManager.removeNode(this);
    },

    onViewResize (screenRatio, aspectRatio) {
        let scale = 1;
        let index = -1;

        for(let i = 0; i < this.scaleData.length; i++) {
            const data = this.scaleData[i];

            if (aspectRatio < data.aspectRatioTo) {
                index = i;                
            }
        }

        this._scale(index)
    },

    _scale (index) {
        let coef;
        if (index === -1) {
            coef = 1;
        } else {
            coef = this.scaleData[index].coefficient;
        }

        // this.lastCoef = coef;
        this.node.setScale(this.originScaleX * coef, this.originScaleY * coef);
    }
});
